import sendWebVitalsResultsToAnalytics from '@/legacy/components/WebVitals/sendWebVitalsResultsToAnalytics'
import useReportWebVitals from '@/legacy/components/WebVitals/useReportWebVitals'

export default function WebVitals() {
  useReportWebVitals(sendWebVitalsResultsToAnalytics)
  return null
}
